const itemCategoriesBasePath = '/item-categories';

export class ItemCategoryPath {
  static index() {
    return itemCategoriesBasePath;
  }
}
